import React, { useState, useRef, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import {
  OSSDatePicker,
  OSSIcon,
  useOnClickOutside,
  formatDate
} from "@oss/components";

/**
 *
 * @param {obj} datesObject - object of values that contain the date object that will be updated
 * @param {func} onBlur - method that will be fired on click outside of the pickers
 * @param {string} startKey - startDate Key that should be mapped to editableValues
 */
const OSSEditableDateRange = ({ datesObject = {}, onBlur = () => {} }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [newDates, setNewDates] = useState({});

  // Need to update a local state value and use it for min max because they get called later
  useEffect(() => {
    setNewDates(datesObject);
  }, [datesObject]);

  const handleStartChange = (dateObj, dateStr) => {
    setNewDates({
      ...newDates,
      startDate: formatDate(dateObj, "yyyy-MM-dd")
    });
  };
  const handleEndChange = (dateObj, dateStr) => {
    setNewDates({
      ...newDates,
      endDate: formatDate(dateObj, "yyyy-MM-dd")
    });
  };

  // Watch for date picker popover to be open or closed
  const [isPickerOpen, setIsPickerOpen] = useState(false);
  const handlePickerOpen = () => {
    setIsPickerOpen(true);
  };
  const handlePickerClose = () => {
    setIsPickerOpen(false);
  };

  const handleBlur = () => {
    if (!isPickerOpen) {
      setIsEditing(false);
      onBlur(newDates);
    }
  };

  const datesRef = useRef();
  useOnClickOutside(datesRef, handleBlur);

  return isEditing ? (
    <Grid container spacing={1} ref={datesRef}>
      <Grid item xs={12} sm={6} md={12} lg={6}>
        <OSSDatePicker
          value={new Date(`${newDates.startDate}T00:00:00`)}
          inputVariant="outlined"
          onChange={handleStartChange}
          onOpen={handlePickerOpen}
          onClose={handlePickerClose}
          minDate={`${newDates.minDate}T00:00:00`}
          maxDate={`${newDates.maxDate}T11:59:59`}
          InputProps={{
            style: {
              background: "white"
            }
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={12} lg={6}>
        <OSSDatePicker
          value={new Date(`${newDates.endDate}T00:00:00`)}
          inputVariant="outlined"
          onChange={handleEndChange}
          onOpen={handlePickerOpen}
          onClose={handlePickerClose}
          minDate={`${newDates.minDate}T00:00:00`}
          maxDate={`${newDates.maxDate}T11:59:59`}
          InputProps={{
            style: {
              background: "white"
            }
          }}
        />
      </Grid>
    </Grid>
  ) : (
    <Typography variant="body2">
      {formatDate(newDates.startDate)} - {formatDate(newDates.endDate)}
      <OSSIcon name="edit" size="small" onClick={() => setIsEditing(true)} />
    </Typography>
  );
};

export default OSSEditableDateRange;
